import StockTabPanelConsignment from './StockTabPanelConsignment';

export default StockTabPanelConsignment;
